var xP = require('../xP');

//TODO: Надо бы сделать ее рабочей и для sheet-ов (для кнопок next и prev).
module.exports = {
  name: 'enabled_on_completed', base: '_item', prototype: {
    init: function (params, control) {
      xP.dependencies.enabled_on_completed.base.init.apply(
        this,
        [{from: [control.root()]}, control]
      );
    },

    process: function () {
      xP.debug(
        'enabled_on_completed', 'enabled_on_completed',
        this.to.first().$element, this.to
      );

      this.result = this.to.first().root().uncompleted();

      var that = this;

      this.to.each(function () {
        this.disable(that.result);
      });
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/dependencies/enabled_on_completed.js
 ** module id = 45
 ** module chunks = 0
 **/